import { LoginResult } from "domain/entities/user";
import { UserRepository } from "domain/repositories";

export default class ResetPasswordUseCase {
    private userRepository: UserRepository;
    
    public constructor(userRepository: UserRepository) {
        this.userRepository = userRepository
    }

    public async resetPassword(email: string): Promise<([LoginResult, null]) | ([null, Error])> {
        return this.userRepository.resetPassword(email);
    }
}